import { lazy } from "react";

const routes = [
  {
    role: "ROLE_FULLFILLMENT_CENTER",
    path: "/Error",
    element: lazy(() => import("../pages/common/Error")),
    noLayout: true,
  },
];

export default routes;
